import { Dialog as DialogComponent } from './Dialog';

export const Dialog = Object.assign(DialogComponent)
